module.exports = __webpack_public_path__ + "static/scale-model-of-four-seasons-houses-in-san-francisco-california-10bb463be74fba2877e8379594eaef04.png";